var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5503 48.4497C76.6647 30.4727 65.4267 12.5641 47.4497 8.4497C29.4727 4.33534 11.5641 15.5733 7.4497 33.5503C3.33535 51.5273 14.5733 69.4359 32.5503 73.5503C50.5273 77.6646 68.4359 66.4267 72.5503 48.4497Z",
    stroke: "white",
    strokeWidth: 6.5947,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5503 48.4497C76.6647 30.4727 65.4267 12.5641 47.4497 8.4497C29.4727 4.33534 11.5641 15.5733 7.4497 33.5503C3.33535 51.5273 14.5733 69.4359 32.5503 73.5503C50.5273 77.6646 68.4359 66.4267 72.5503 48.4497Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.059 18.5056C46.5784 18.5056 51.9051 23.8324 51.9051 30.3517C51.9051 36.8711 46.5784 42.1979 40.059 42.1979C33.5397 42.1979 28.2129 36.8711 28.2129 30.3517C28.2129 23.8324 33.4602 18.5056 40.059 18.5056Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0675 42.9929H34.9705C26.6225 42.9929 19.7852 49.8303 19.7852 58.1782V70.5014V70.6604L20.6597 70.8989C28.6101 73.3635 35.527 75.1125 41.1718 75.1125C52.3024 75.1125 58.8217 71.0579 59.2192 70.8194L60.0143 70.4219H60.0938V58.0987C60.1733 49.7508 53.4154 42.9929 45.0675 42.9929ZM42.3644 66.8442L40.2177 70.0244C40.2177 70.1039 40.1382 70.1039 40.0587 70.1039C39.9792 70.1039 39.9792 70.1039 39.8997 70.0244L37.9121 66.8442V66.7647L38.9457 51.3409C38.9457 51.2614 39.0252 51.1819 39.1047 51.1819H41.1718C41.2513 51.1819 41.3308 51.2614 41.3308 51.3409L42.4439 66.7647C42.3644 66.7647 42.3644 66.7647 42.3644 66.8442ZM41.4103 50.7048H38.9457L36.7991 46.2526C36.7991 45.8551 37.1171 45.4575 37.5941 45.4575H42.7619C43.1594 45.4575 43.5569 45.7756 43.5569 46.2526L41.4103 50.7048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/NoUser.8c1d76dcd5da72c1ff33b09ff71f0a8b.svg";
export { ForwardRef as ReactComponent };